import { Component, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { MainAppService } from '../../services/main-app.service';
import { AppMainComponent } from '../app-main/app-main.component';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { Config } from '../../models/config.model';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss']
})
export class AppTopbarComponent {

    _RestEndpoint = RestEndpoint;
    _Config = Config;

    app = inject(MainAppService);
    appComponent = inject(AppMainComponent);

    getUserName(): string {
        return this.app.getUserName();
    }

    getUserNameShort(): string {
        let name = this.getUserName();
        return name != null && name.length > 0 ? name.substring(0, 1) : "?";
    }

    async changePassword(): Promise<void> {
        let form = this.app.tForm("general.changePassword", new FrontendFormDefinition([
            new FrontendFieldDefinition("oldPassword", "", FrontendFieldType.password, { mandatory: true }),
            new FrontendFieldDefinition("newPassword", "", FrontendFieldType.password, { mandatory: true }),
            new FrontendFieldDefinition("newPasswordRepeat", "", FrontendFieldType.password, { mandatory: true, validator:
                (field, item) => field.getValue() != item.getValue("newPassword") ? this.app.t("general.changePassword.newPasswordRepeat_error1") : null})
        ]));
        if (await this.app.messageDialog.form(form, this.app.t("general.changePassword.title")) != "ok") {
            return;
        }

        try {
            await this.app.auth.changePassword(form.getValue("oldPassword") as string, form.getValue("newPassword") as string);
            this.app.showToast("success",  this.app.t("general.changePassword.changed_title"),  this.app.t("general.changePassword.changed"));
        }
        catch (ex) {
            this.app.showToast("error",  this.app.t("general.error"),  this.app.t("general.changePassword.error"));
        }
    }

    async logout(): Promise<void> {
        await this.app.auth.logout();
    }

    buttonClick(button: MenuItem): void {
        if (button.command != null) {
            button.command(null);
        }
    }

    async languageClicked(): Promise<void> {
        let languages = await RestEndpoint.main().run("api/app/languages").listStrings();
        this.app.openContextMenu(languages.map(lng => ({
                label: lng == "de" ? "Deutsch" : lng == "en" ? "English" : lng == "fr" ? "Français" : lng == "es" ? "Español" : lng,
                icon: RestEndpoint.getUrl() + "/api/app/flag/" + lng,
                command: async () => {
                    if (Config.get().warningOnSwitchLanguage && !(await this.app.messageDialog.yesNo("Warnung: Beim Ändern der Sprache gehen eventuell ungespeicherte Änderungen verloren. Fortfahren?", this.app.t("general.warning")))) {
                        return;
                    }
                    await this.app.setLanguage(lng);
                    this.app.reloadPage();
                    //this.app.showToast("warn", this.app.t("general.info"), this.app.t("general.languageChanged_note"));
                }
            })));
    }

    async helpClicked(event: any): Promise<void> {
        let files = await RestEndpoint.main().query({ language: this.app.language }).run("api/app/helpFiles").listStrings();
        this.app.openContextMenu(files.map(file => ({
                label: file,
                command: async () => {
                    let blob = await RestEndpoint.main().query({ language: this.app.language, name: file }).runBlob("api/app/helpFile");
                    const blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl, '_blank');
                }
            })));
    }

    menuButtonClick(): void {
        this.app.openContextMenu([
            this.app.mainConfig.authRules.canChangePassword ? {
                label: this.app.t("general.changePassword.title"),
                icon: "fas fa-key",
                command: async () => this.changePassword()
            } : null,
            {
                label: this.app.t("general.logout"),
                icon: "fas fa-sign-out-alt",
                command: async () => this.logout()
            }
        ], "topbar-context-menu");
    }
}
